import { SITE } from './site'

/**
 * A megrendeléskor elfogadott jogi dokumentumok változatlan azonosítója.
 *
 * Új érdemi feltételhez új verzió tartozik. Az elfogadott rendelés ezt az
 * értéket menti, ezért egy későbbi módosítás nem írja át a korábbi szerződést.
 */
/*
  2026-08-15: a konverziómérés látogatásazonosítója a böngésző helyi
  tárolójába került (`voxora.meres`). Ez érdemi változás — a korábbi szöveg
  még azt állította, hogy a mérés semmit nem tárol a böngészőben —, ezért
  új verzió tartozik hozzá: a korábban leadott rendelések változatlanul a
  2026-08-12-es szöveggel jöttek létre.
*/
/*
  2026-08-20: a weboldal a Meta Platforms mérőkódját (Meta pixel) kezdte
  használni a hirdetései méréséhez. Ez a korábbiaktól MINŐSÉGBEN tér el —
  eddig egyetlen adat sem ment harmadik félhez mérési célból, és a
  tájékoztató kifejezetten azt állította, hogy a weboldal nem használ
  hirdetési célú tárolást. Új címzett, új cél, EGT-n kívüli továbbítás és
  új jogalap (hozzájárulás) került a képbe, ezért új verzió tartozik
  hozzá: a korábban leadott rendelések változatlanul a 2026-08-15-ös
  szöveggel jöttek létre.

  A verzió emelése egyben ÚJRA MEGKÉRDEZI a látogatót: a hozzájárulási
  panel minden olyan böngészőben előjön, amelyben a tárolt válasz még a
  korábbi szöveghez tartozik (lásd `consent.ts`).
*/
/*
  2026-08-22: a Meta pixel alapallapota opt-inrol opt-outra valtozott. A
  tajekoztato dinamikus szovege ezt kimondja, a minden oldalon elerheto
  sutiikon pedig az azonnali kikapcsolast biztosítja.
*/
export const LEGAL_VERSION = '2026-08-22'
export const LEGAL_EFFECTIVE_DATE = '2026. augusztus 22.'

/** A NAV által kiállított igazolással 2026. augusztus 12-én ellenőrzött adatok. */
export const BUSINESS = {
  brand: 'VOXORA',
  name: 'Székely Tibor Levente egyéni vállalkozó',
  shortName: 'Székely Tibor Levente e.v.',
  seat: '1154 Budapest, Domaháza utca 46.',
  registrationAuthority: 'Nemzeti Adó- és Vámhivatal – Egyéni Vállalkozók Nyilvántartása',
  registrationNumber: '59845982',
  taxNumber: '90586961-1-42',
  vatStatus: 'alanyi adómentes',
  email: SITE.email || 'hello@voxora.hu',
  phone: SITE.phone || '+36 1 445 3681',
  website: 'https://voxora.hu'
} as const

export const HOSTING = {
  name: 'OVH SAS (OVHcloud)',
  seat: '2 rue Kellermann, 59100 Roubaix, Franciaország',
  registrationNumber: 'RCS Lille Métropole 424 761 419',
  /** A kiszolgálók fizikai helye — az adatok nem hagyják el az EGT-t. */
  datacenter: 'Franciaország (Európai Gazdasági Térség)',
  website: 'https://www.ovhcloud.com/hu/'
} as const

export const SUPABASE_PROCESSOR = {
  name: 'Supabase Pte. Ltd.',
  purpose: 'adatbázis, fájltárolás, hitelesítés és szerveroldali funkciók',
  website: 'https://supabase.com'
} as const

export const KVIKK_PROCESSOR = {
  name: 'Kvikk.hu Kft.',
  seat: '3264 Kisnána, Béke utca 43.',
  registrationNumber: '10-09-039300',
  purpose: 'csomagpontkeresés, fuvarmegrendelés, címke és nyomon követés',
  website: 'https://kvikk.hu'
} as const

export const GOOGLE_PROCESSOR = {
  name: 'Google Ireland Limited',
  seat: 'Gordon House, Barrow Street, Dublin 4, Írország',
  purpose: 'e-mailes kapcsolattartás'
} as const

/**
 * A META — ÉS AMIÉRT NEM „ADATFELDOLGOZÓ" A CÍMKÉJE.
 *
 * ────────────────────────────────────────────────────────────────────
 * KÖZÖS ADATKEZELÉS, NEM ADATFELDOLGOZÁS
 *
 * Kézenfekvő lenne a Metát a Supabase és a Kvikk mellé sorolni
 * adatfeldolgozóként. Jogilag AZ LENNE A HIBÁS: az Európai Unió
 * Bírósága a Fashion ID ügyben (C-40/17) kimondta, hogy a közösségi
 * mérőkódot beépítő honlap üzemeltetője és a szolgáltató a látogatói
 * adat GYŰJTÉSE és TOVÁBBÍTÁSA tekintetében KÖZÖS ADATKEZELŐ — mert az
 * üzemeltető is dönt arról, hogy a gyűjtés egyáltalán megtörténjen, és
 * abból ő maga is hasznot húz.
 *
 * A Meta ehhez saját közös adatkezelői kiegészítést ad a Business Tools
 * feltételei között. A látogató felé viszont AZ ÜZEMELTETŐ felel azért,
 * hogy a hozzájárulás beszerzése és a tájékoztatás rendben legyen.
 * ────────────────────────────────────────────────────────────────────
 */
export const META_CONTROLLER = {
  name: 'Meta Platforms Ireland Limited',
  seat: 'Merrion Road, Dublin 4, D04 X2K5, Írország',
  registrationNumber: '462932',
  purpose:
    'a Facebook- és Instagram-hirdetések eredményének mérése, a hirdetések célzása és hasonló közönségek képzése',
  /** A pixel a Meta amerikai anyavállalatához is továbbít adatot. */
  usEntity: 'Meta Platforms, Inc. (1 Meta Way, Menlo Park, CA 94025, Amerikai Egyesült Államok)',
  /**
   * A továbbítás alapja. A Bizottság (EU) 2023/1795 megfelelőségi
   * határozata jelenleg HATÁLYBAN VAN, de bírósági felülvizsgálat alatt
   * áll (C-703/25. P. ügy). Ha megdől, ennek a bekezdésnek és a
   * mérésnek is azonnal változnia kell.
   */
  transferBasis:
    'az Európai Bizottság (EU) 2023/1795 megfelelőségi határozata (EU–USA adatvédelmi keret)',
  privacyPolicy: 'https://www.facebook.com/privacy/policy',
  website: 'https://www.facebook.com/business/tools/meta-pixel'
} as const

export const NAIH = {
  name: 'Nemzeti Adatvédelmi és Információszabadság Hatóság',
  seat: '1055 Budapest, Falk Miksa utca 9–11.',
  postal: '1363 Budapest, Pf. 9.',
  phone: '+36 1 391 1400',
  email: 'ugyfelszolgalat@naih.hu',
  website: 'https://naih.hu'
} as const

export const CONSUMER_AUTHORITY = {
  name: 'Budapest Főváros Kormányhivatala Fogyasztóvédelmi Főosztály',
  seat: '1117 Budapest, Prielle Kornélia utca 4/b.',
  phone: '+36 1 450 2598',
  email: 'fogyasztovedelem@bfkh.gov.hu',
  website:
    'https://kormanyhivatalok.hu/kormanyhivatalok/budapest/megye/szervezet/fogyasztovedelmi-foosztaly'
} as const

export const CONCILIATION_BOARD = {
  name: 'Budapesti Békéltető Testület',
  seat: '1016 Budapest, Krisztina körút 99. I. emelet 111.',
  postal: '1253 Budapest, Pf. 10.',
  phone: '+36 1 488 2131',
  email: 'bekelteto.testulet@bkik.hu',
  website: 'https://bekeltet.bkik.hu'
} as const

export const LEGAL_LINKS = [
  { path: '/impresszum', label: 'Impresszum' },
  { path: '/aszf', label: 'ÁSZF' },
  { path: '/adatkezeles', label: 'Adatkezelés' },
  { path: '/sutik', label: 'Sütik és helyi tárolás' },
  { path: '/fogyasztoi-tajekoztato', label: 'Fogyasztói tájékoztató' }
] as const

export type LegalPath = (typeof LEGAL_LINKS)[number]['path']
